import React from "react";
import { Switch, Route, withRouter, Redirect } from "react-router-dom";
import PersonalInfo from "./PersonalInfo";

function PersonalInfoIndex({match, goToUpdate, goToDetail, onCancel, formComponent}) {
    return (
        <Switch>
            <Redirect exact from={match.path} to={`${match.path}/detail`} />
            <Route
                exact
                path={`${match.path}/add`}
                render={(props) => (
                    <PersonalInfo
                        {...props}
                        mode="add"
                        title="Create File"
                        onCancel={onCancel}
                        goToUpdate={goToUpdate}
                        goToDetail={goToDetail}
                        formComponent={formComponent}
                    />
                )}
            />
            <Route
                exact
                path={`${match.path}/detail`}
                render={(props) => (
                    <PersonalInfo
                        {...props}
                        mode="detail"
                        title="Client File"
                        onCancel={onCancel}
                        goToUpdate={goToUpdate}
                        goToDetail={goToDetail}
                        formComponent={formComponent}
                    />
                )}
            />
            <Route
                exact
                path={`${match.path}/update`}
                render={(props) => (
                    <PersonalInfo
                        {...props}
                        mode="update"
                        title="Update File"
                        onCancel={onCancel}
                        goToUpdate={goToUpdate}
                        goToDetail={goToDetail}
                        formComponent={formComponent}
                    />
                )}
            />
        </Switch>
    );
}

export default withRouter(PersonalInfoIndex);